import React from 'react'

import { SupplierBrand } from '../../../models'

interface SupplierBrandTableProps {
    supplierBrand: SupplierBrand
}

export const SupplierBrandTable = (props: SupplierBrandTableProps) => {
    const { supplierBrand } = props

    return (
        <table className='table'>
            <tbody>
                <tr>
                    <th>Name</th>
                    <td>{supplierBrand.name}</td>
                </tr>
            </tbody>
        </table>
    )
}
